<template>
  <v-overlay
    v-model="display"
    scrim="black"
    eager
    transition="slide-x-transition"
  >
    <template #default>
      <div
        class="drawer"
        :style="cssVars"
      >
        <slot />
      </div>
    </template>
  </v-overlay>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 300,
    },
    backgroundColor: {
      type: String,
      default: 'transparent',
    },
  },
  computed: {
    display: {
      get() { return this.modelValue; },
      set(display) {
        this.$emit('update:model-value', display);
      },
    },
    cssVars() {
      return {
        '--width': `${this.width}px`,
        '--backgroundColor': this.backgroundColor,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  position: fixed;
  top: 0;
  left: 0;
  width: var(--width);
  height: 100vh;
  background-color: var(--backgroundColor);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.2);
  padding: 1rem;
  transition: transform 0.2s ease;
}
</style>
